module.exports = "<div class=\"password-change row\"> <div class=\"col-sm-12\"> <div class=\"row mainbuttons\"> <div class=\"col-sm-2 col-sm-offset-6\"> <button type=\"reset\" class=\"btn btn-sub-serf\" ng-click=\"vm.back()\"> <span data-translate=\"ZURUECK\"></span> </button> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/authentication/component/verifyView/verifyView.html
// module id = fqwK
// module chunks = 0